export default __webpack_public_path__ + "static/media/ic_sort_bottom.ad8a9b4c.svg";